class FaqAccordeon {
    static init() {
        this.items = document.querySelectorAll(".c-faq__list-item");
        if (this.items) {
            window.addEventListener('resize', () => {
                this.items.forEach(item => {
                    item.style.maxHeight = item.querySelector('.c-faq__list-item-title').offsetHeight + "px";
                })
            })
            this.items.forEach(item => {
                item.style.maxHeight = item.querySelector('.c-faq__list-item-title').offsetHeight + "px";
                item.querySelector('.c-faq__btn').addEventListener('click', (e) => {
                    // this.items.forEach(item => {
                    //     if (!e.target.closest(".c-faq__list-item").classList.contains('open')) {
                    //         item.classList.remove('open');
                    //         e.target.closest(".c-faq__list-item").classList.add('open');
                    //     }
                    // })
                    if (e.target.closest(".c-faq__list-item").classList.contains('open')) {
                        e.target.closest(".c-faq__list-item").classList.remove('open');
                    } else {
                        e.target.closest(".c-faq__list-item").classList.add('open');
                    }
                })
            })
        }
    }
}

export default FaqAccordeon;


// WEBPACK FOOTER //
// ./src/scripts/components/faqAccordeon.js